import { ReportsScreen } from "./reports.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";
import { ReportDetailsRoutes } from "../report-details/report-details.routes";

export const ReportsRoutes: RouteDefinition[] = [
	{
		path: Paths.reports.path,
		element: <ReportsScreen />,
		requiredPermissions: ["UserInAccountPermission_ReportAdmin_Read"],
	},
	...ReportDetailsRoutes,
];
